import { createContext, Dispatch, SetStateAction } from 'react';

interface SignUpContextProps {
    useVerified: [boolean, Dispatch<SetStateAction<boolean>>];
    useValue: [string, Dispatch<SetStateAction<string>>]
    useMarketing: [boolean, Dispatch<SetStateAction<boolean>>];
    useLocation: [boolean, Dispatch<SetStateAction<boolean>>];
    useInputValue: [string, Dispatch<SetStateAction<string>>];
    useInputAuthCode: [string, Dispatch<SetStateAction<string>>];
    useSelectedTermCategories: [string[], Dispatch<SetStateAction<string[]>>];
    nickname?: string;
    kakaoId?: number;
    appleId?: string;
    googleId?: string;
}

const SignUpContext = createContext<SignUpContextProps>({} as SignUpContextProps);

export default SignUpContext;
